import React from 'react';
import { Box, Paper, Typography, Chip, useTheme } from '@mui/material';
import { QUESTION_TYPE_LABELS } from '@/components/campaigns/CampaignQuestionsEditor/constants';
import { QuestionType } from '@/components/campaigns/CampaignQuestionsEditor/types';
import QuestionTypeIcon from '@/components/calls/CallInsights/QuestionTypeIcon';
import type { GlobalPromptQuestion } from './types';

interface GlobalPromptQuestionCardProps {
    question: GlobalPromptQuestion;
    number: number;
}

const GlobalPromptQuestionCard: React.FC<GlobalPromptQuestionCardProps> = ({ question, number }) => {
    const theme = useTheme();
    const title = `${number}. ${question.questionTitle || 'Question'}`;
    const questionType = question.questionType as unknown as QuestionType;

    return (
        <Paper variant="outlined" sx={{ p: 1.5, backgroundColor: theme.palette.gray[10] }} data-testid={`global-prompt-question-${number}`}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, mb: 1 }}>
                <Typography variant="h5">{title}</Typography>
                <Chip
                    size="small"
                    icon={<QuestionTypeIcon type={questionType} />}
                    label={QUESTION_TYPE_LABELS[questionType]}
                    sx={{ px: 0.5 }}
                />
            </Box>
            <Typography variant="body2">{question.questionText || 'No question text provided'}</Typography>
        </Paper>
    );
};

export default GlobalPromptQuestionCard;
